export default "__VITE_ASSET__62950373__"